import './category-color.style.sass';
import template from './category-color.tpl.pug';

class CategoryColorController {
    $onChanges(changeObject) {
        if (changeObject.color || changeObject.fill) {
            this.borderColor = this.fill ? null : this.color;
            this.backgroundColor = this.fill ? this.color : null;
        }
    }
}

export default {
    selector: 'dbACategoryColor',
    template: template(),
    controller: CategoryColorController,
    bindings: {
        color: '<',
        fill: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-color/category-color.cmpt.js